import React from "react";

/**
 * DeviceFrame
 * -----------
 * Realistic iPhone 15 Pro bezel rendered as a styled <div> shell.
 * Agent C may swap in a pixel-accurate SVG; the outer shape + sizing is stable here.
 *
 * Props:
 *   - type:      "iphone-15-pro" (default) | "pixel-8-pro" — display only for now.
 *   - width:     override inner screen width (default 320).
 *   - height:    override inner screen height (default 680).
 *   - children:  <PlatformChrome> subtree (fills the screen viewport).
 *
 * The bezel is a dark titanium-style gradient. The 3D perspective tilt comes from
 * the parent <PreviewFrame>, not from this component.
 */
export default function DeviceFrame({
  type = "iphone-15-pro",
  width = 320,
  height = 680,
  children,
}) {
  const bezelPad = 12;

  return (
    <div
      className="vella-device-frame"
      data-device-type={type}
      style={{
        position: "relative",
        width: width + bezelPad * 2,
        background:
          "linear-gradient(145deg, #2a2a3e 0%, #1a1a2e 40%, #2d2d44 70%, #1e1e30 100%)",
        borderRadius: 55,
        padding: `${bezelPad + 2}px ${bezelPad}px`,
        boxShadow: [
          "0 2px 6px rgba(0,0,0,0.15)",
          "inset 0 1px 0 rgba(255,255,255,0.05)",
          "inset 0 -1px 0 rgba(0,0,0,0.3)",
        ].join(", "),
      }}
    >
      {/* Side button studs — cosmetic */}
      <div
        aria-hidden
        style={{
          position: "absolute",
          right: -3,
          top: 110,
          width: 3,
          height: 30,
          background: "linear-gradient(180deg, #2a2a3e, #1a1a2e)",
          borderRadius: "0 2px 2px 0",
        }}
      />
      <div
        aria-hidden
        style={{
          position: "absolute",
          left: -3,
          top: 100,
          width: 3,
          height: 28,
          background: "linear-gradient(180deg, #2a2a3e, #1a1a2e)",
          borderRadius: "2px 0 0 2px",
        }}
      />

      {/* Inner screen — the "viewport" platform chrome renders into */}
      <div
        className="vella-device-screen"
        style={{
          position: "relative",
          width,
          height,
          background: "#fff",
          borderRadius: 42,
          overflow: "hidden",
        }}
      >
        {children}
      </div>
    </div>
  );
}
